var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoal8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2876 14.0016 38.6157 24.8288c-.427.4165-.6405.7635-.6405 1.5964v30.2607c0 .3471.2847.6247.6405.6247h12.0277c.3559 0 .6406-.2776.6406-.6247V14.2792c.0712-.4164-.2135-1.0411-.9964-.2776ZM16.7665 28.0215 5.09463 38.8487c-.42702.4165-.64053.7635-.64053 1.5964v16.1714c0 .3471.28468.6247.64053.6247H17.1224c.3558 0 .6405-.2776.6405-.6247V28.2991c.0712-.347-.2135-.9717-.9964-.2776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6252.883893c0-.069406 0-.208213-.0712-.277618-.0712-.069406-.1424-.06941-.2135-.06941h-.1423L46.3019 2.48023h-.1423c-.0712 0-.1424.06939-.1424.06939-.1423.13881-.1423.34704 0 .48585l.0712.06941 2.0639 2.01275L27.94 24.8288l-9.3233-9.0921c-.0711-.0694-.2846-.0694-.3558 0l-2.5621 2.4986L.753085 32.8104c-.07117.0694-.07117.2776 0 .347L3.31519 35.656c.07117.0694.28468.0694.35585 0L18.4744 21.2891l6.7612 6.5935 2.5621 2.4986c.0712.0694.2847.0694.3558 0L51.0703 8.03267l2.1351 2.08213c.1423.1388.3558.1388.4982 0 .0711-.0694.0712-.13879.0712-.2082l1.9927-8.88389-.1423-.138817Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.6338 29.9647-5.6224 5.5525c-.1424.0694-.2847.0694-.3559 0l-5.1242-5.0666c-.9252-.9023-1.1387-.1388-1.1387.2082v26.0965c0 .347.2847.6246.6405.6246h12.0277c.3559 0 .6406-.2776.6406-.6246V30.2424c0-.4859-.2847-1.1105-1.0676-.2777Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal8);
export default __webpack_public_path__ + "static/media/goal-8.d678036d107c4a1a88dff711bd60449f.svg";
export { ForwardRef as ReactComponent };